// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectCustodialPlanMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { CustodialData } from "../../../../Utils/Instruments/CustodialData.js";

export let CustodialPlanMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

CustodialPlanMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

CustodialPlanMessageProcessor.prototype.decode = function (fs)
{
    let ff = FieldsFactory
    let message = new DirectCustodialPlanMessage();
    message.Id = fs.GetValue(ff.FIELD_CUSTODIAL_PLAN_ID);
    message.Name = fs.GetValue(ff.FIELD_NAME);

    let groups = fs.GetGroups(ff.CUSTODY_FEE_GROUP);

    for (let i = 0; i < groups.length; i++)
    {
        let custodial = groups[i];
        let data = new CustodialData();

        let InstrumentId = custodial.GetValue(ff.FIELD_INSTRUMENT_ID);
        if (InstrumentId !== null)
            data.InstrumentId = InstrumentId;

        let InstrumentGroupId = custodial.GetValue(ff.FIELD_INSTRUMENTTYPE_ID);
        if (InstrumentGroupId !== null)
            data.InstrumentGroupId = InstrumentGroupId

        data.Fee = custodial.GetValue(ff.FIELD_CUSTODIAL_FEE);
        data.Measure = custodial.GetValue(ff.FIELD_CUSTODIAL_MEASURE);
        message.Data.push(data);
    }

    return [message];
}